import { z } from 'zod';
// Transaction Type
export var TransactionType;
(function (TransactionType) {
    TransactionType["TRANSACTION"] = "TRANSACTION";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["ADJUSTMENT"] = "ADJUSTMENT";
})(TransactionType || (TransactionType = {}));
// Transaction Status
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["CLEARED"] = "CLEARED";
    TransactionStatus["RECONCILED"] = "RECONCILED";
})(TransactionStatus || (TransactionStatus = {}));
// transaction request
export const transactionRequestSchema = z.object({
    id: z.string().uuid(),
    budgetId: z.string().uuid(),
    accountId: z.string().uuid(),
    dateEpoch: z.number(),
    type: z.nativeEnum(TransactionType),
    status: z.nativeEnum(TransactionStatus),
    payee: z.string().optional(),
    notes: z.string().optional(),
    bucketId: z.string().optional(),
    transferAccountId: z.string().uuid().optional(),
    transferTransactionId: z.string().uuid().optional(),
    externalTransactionId: z.string().optional(),
    inflow: z.coerce.number().optional(),
    outflow: z.coerce.number().optional(),
});
// transaction
export const transactionSchema = transactionRequestSchema.extend({});
// Split schema
export const transactionSplitSchema = z.object({
    id: z.string().uuid(),
    bucketId: z.string().uuid(),
    amount: z.coerce.number(),
});
// Split request schema
export const transactionSplitRequestSchema = z.object({
    id: z.string().uuid(),
    budgetId: z.string().uuid(),
    splits: z.array(transactionSplitSchema).min(2, 'At least one split is required'),
});
// transaction importer type
export var TransactionImporterType;
(function (TransactionImporterType) {
    TransactionImporterType["GO_CARDLESS"] = "GO_CARDLESS";
    TransactionImporterType["OFX"] = "OFX";
    TransactionImporterType["QIF"] = "QIF";
})(TransactionImporterType || (TransactionImporterType = {}));
export const transactionImporterTypeSelectOptions = [
    { value: TransactionImporterType.OFX, label: 'OFX/QFX (Open Financial Exchange)' },
    { value: TransactionImporterType.QIF, label: 'QIF (Quicken Interchange Format)' },
    { value: TransactionImporterType.GO_CARDLESS, label: 'GoCardless (JSON)' },
];
// Importer schema
export const transactionImporterSchema = z.object({
    accountId: z.string().uuid(),
    budgetId: z.string().uuid(),
    type: z.nativeEnum(TransactionImporterType),
    file: z.instanceof(File),
});
